import httpClient from '../httpClient';

const listingBulks = 'listing-bulks';

const createListingBulk = body => {
  return httpClient.post(`${listingBulks}/upload`, body);
};

const discardListingBulk = bulkId => {
  return httpClient.delete(`${listingBulks}/${bulkId}/discard`);
};

const publishListingBulk = bulkId => {
  return httpClient.post(`${listingBulks}/${bulkId}/publish`);
};

const getListingBulks = params => {
  return httpClient.get(`${listingBulks}`, { params });
};

const getListingBulk = id => {
  return httpClient.get(`${listingBulks}/${id}`);
};

export default {
  createListingBulk,
  discardListingBulk,
  getListingBulks,
  getListingBulk,
  publishListingBulk,
};
